module.exports = __webpack_public_path__ + "img/manAvatar.91b40067.png";